import "./Contact.css";

const Contact = () => {
    return (
        <section className="contact" id="contact">
            <div className="contact-container">

                {/* Left Section */}
                <div className="contact-info">
                    <h2>Let's Design Your Dream Home</h2>
                    <p>
                        Get in touch with us for a free consultation. We’d love to
                        understand your space and bring your vision to life.
                    </p>

                    <div className="info-block">
                        <span>📍</span>
                        <p>Bangalore, India</p>
                    </div>

                    <div className="info-block">
                        <span>📞</span>
                        <p>+91 9769611279</p>
                    </div>

                    <div className="info-block">
                        <span>✉️</span>
                        <p>support@elevatespace.in</p>
                    </div>

                    <div className="contact-note">
                        We provide end-to-end interior solutions including modular kitchens,
                        wardrobes, TV units, and complete home interiors. 
                        <br /><br />
                        Expect response within 24-48 hours. We look forward to connecting with you!
                    </div>
                </div>

                {/* Right Section */}
                <div className="contact-form">
                    <h3>Request a Free Consultation</h3>

                    <form>
                        <input type="text" placeholder="Your Name" required />
                        <input type="email" placeholder="Email Address" required />
                        <input type="tel" placeholder="Phone Number" required />
                        <textarea placeholder="Tell us about your home requirements" rows="4"></textarea>

                        <button type="submit">Submit</button>
                    </form>
                </div>

            </div>
        </section>
    );
}


export { Contact };